import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import sha256 from 'crypto-js/sha256';
import CryptoJS from 'crypto-js';
import ApiHelper from 'utils/apiHelper';
import { logout } from '../../redux/slices/auth/authSlice';
import { validatePassword } from 'utils/commonHelpers';

const ChangePasswordDialog = ({ onClose }) => {
    const dispatch = useDispatch();
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleSubmit = () => {
        if (oldPassword === '') {
            toast.error('Please type the current password.');
            return true;
        } else {
            if (newPassword === '') {
                toast.error('New password is required.');
                return true;
            }
            if (!validatePassword(newPassword)) {
                toast.warning('Password should be at least 8 characters, and should contain capital & lower letter and number');
                return true;
            }
            if (newPassword !== confirmPassword) {
                toast.error(`Confirm password is incorrect`);
                return true;
            }
        }

        ApiHelper.post('/api/auth/change_password/', {
            old_password: sha256(oldPassword).toString(CryptoJS.enc.Hex),
            new_password: sha256(newPassword).toString(CryptoJS.enc.Hex)
        })
            .then(() => {
                toast.success('Successfully changed.');
                onClose();
                dispatch(logout());
            })
            .catch((err) => {
                if (err.response.data.message !== '') {
                    toast.error(`Failed! ${err.response.data.message}`);
                } else {
                    toast.error('Failed to change the password.');
                }
            });
    };

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Change Password</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{ width: '100%' }}
                        label="Old Password"
                        type="password"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{ width: '100%' }}
                        label="New Password"
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{ width: '100%' }}
                        label="Confirm Password"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};

ChangePasswordDialog.propTypes = {
    onClose: PropTypes.func
};

export default ChangePasswordDialog;
